/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ArticleListMetricsRead from '../model/ArticleListMetricsRead';
import ArticleMetricsRead from '../model/ArticleMetricsRead';
import BrandListMetricsRead from '../model/BrandListMetricsRead';
import BrandMetricsRead from '../model/BrandMetricsRead';
import FileListMetricsRead from '../model/FileListMetricsRead';
import FileMetricsRead from '../model/FileMetricsRead';
import ForbiddenError from '../model/ForbiddenError';
import ImageListMetricsRead from '../model/ImageListMetricsRead';
import ImageMetricsRead from '../model/ImageMetricsRead';
import IngredientListMetricsRead from '../model/IngredientListMetricsRead';
import IngredientMetricsRead from '../model/IngredientMetricsRead';
import ProductListMetricsRead from '../model/ProductListMetricsRead';
import ProductMetricsRead from '../model/ProductMetricsRead';
import RecipeListMetricsRead from '../model/RecipeListMetricsRead';
import RecipeMetricsRead from '../model/RecipeMetricsRead';
import UnauthorizedError from '../model/UnauthorizedError';
import VideoListMetricsRead from '../model/VideoListMetricsRead';
import VideoMetricsRead from '../model/VideoMetricsRead';

/**
* Metrics service.
* @module api/MetricsApi
* @version 1.7.2
*/
export default class MetricsApi {

    /**
    * Constructs a new MetricsApi. 
    * @alias module:api/MetricsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getArticleListMetrics operation.
     * @callback module:api/MetricsApi~getArticleListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ArticleListMetrics resource.
     * @param {module:api/MetricsApi~getArticleListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleListMetricsRead}
     */
    getArticleListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleListMetricsRead;
      return this.apiClient.callApi(
        '/articles/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleMetrics operation.
     * @callback module:api/MetricsApi~getArticleMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ArticleMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getArticleMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleMetricsRead}
     */
    getArticleMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleMetricsRead;
      return this.apiClient.callApi(
        '/articles/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandListMetrics operation.
     * @callback module:api/MetricsApi~getBrandListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a BrandListMetrics resource.
     * @param {module:api/MetricsApi~getBrandListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandListMetricsRead}
     */
    getBrandListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandListMetricsRead;
      return this.apiClient.callApi(
        '/brands/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandMetrics operation.
     * @callback module:api/MetricsApi~getBrandMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a BrandMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getBrandMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandMetricsRead}
     */
    getBrandMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrandMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandMetricsRead;
      return this.apiClient.callApi(
        '/brands/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getFileListMetrics operation.
     * @callback module:api/MetricsApi~getFileListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a FileListMetrics resource.
     * @param {module:api/MetricsApi~getFileListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileListMetricsRead}
     */
    getFileListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileListMetricsRead;
      return this.apiClient.callApi(
        '/files/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getFileMetrics operation.
     * @callback module:api/MetricsApi~getFileMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a FileMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getFileMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileMetricsRead}
     */
    getFileMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getFileMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileMetricsRead;
      return this.apiClient.callApi(
        '/files/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageListMetrics operation.
     * @callback module:api/MetricsApi~getImageListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ImageListMetrics resource.
     * @param {module:api/MetricsApi~getImageListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageListMetricsRead}
     */
    getImageListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageListMetricsRead;
      return this.apiClient.callApi(
        '/images/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageMetrics operation.
     * @callback module:api/MetricsApi~getImageMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ImageMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getImageMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageMetricsRead}
     */
    getImageMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageMetricsRead;
      return this.apiClient.callApi(
        '/images/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getIngredientListMetrics operation.
     * @callback module:api/MetricsApi~getIngredientListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a IngredientListMetrics resource.
     * @param {module:api/MetricsApi~getIngredientListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientListMetricsRead}
     */
    getIngredientListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientListMetricsRead;
      return this.apiClient.callApi(
        '/ingredients/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getIngredientMetrics operation.
     * @callback module:api/MetricsApi~getIngredientMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a IngredientMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getIngredientMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientMetricsRead}
     */
    getIngredientMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getIngredientMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientMetricsRead;
      return this.apiClient.callApi(
        '/ingredients/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductListMetrics operation.
     * @callback module:api/MetricsApi~getProductListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ProductListMetrics resource.
     * @param {module:api/MetricsApi~getProductListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductListMetricsRead}
     */
    getProductListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductListMetricsRead;
      return this.apiClient.callApi(
        '/products/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductMetrics operation.
     * @callback module:api/MetricsApi~getProductMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ProductMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getProductMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductMetricsRead}
     */
    getProductMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductMetricsRead;
      return this.apiClient.callApi(
        '/products/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeListMetrics operation.
     * @callback module:api/MetricsApi~getRecipeListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a RecipeListMetrics resource.
     * @param {module:api/MetricsApi~getRecipeListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeListMetricsRead}
     */
    getRecipeListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeListMetricsRead;
      return this.apiClient.callApi(
        '/recipes/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeMetrics operation.
     * @callback module:api/MetricsApi~getRecipeMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a RecipeMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getRecipeMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeMetricsRead}
     */
    getRecipeMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeMetricsRead;
      return this.apiClient.callApi(
        '/recipes/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoListMetrics operation.
     * @callback module:api/MetricsApi~getVideoListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a VideoListMetrics resource.
     * @param {module:api/MetricsApi~getVideoListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoListMetricsRead}
     */
    getVideoListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoListMetricsRead;
      return this.apiClient.callApi(
        '/videos/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoMetrics operation.
     * @callback module:api/MetricsApi~getVideoMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a VideoMetrics resource.
     * @param {String} id 
     * @param {module:api/MetricsApi~getVideoMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoMetricsRead}
     */
    getVideoMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoMetricsRead;
      return this.apiClient.callApi(
        '/videos/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
